import { commentList } from '../../../api/g/comment'
import {assign, getServerTime, dataFormat } from '../../../utils/base'
import { update } from '../../../utils/vuex'

const state = {
    talkList     : null,
    userMap      : null
}
export default {
    namespaced: true,
    state,    
    getters: {
        talkList(state) {
            return state.talkList || null
        },
        userMap(state) {
            return state.userMap || null
        }
    },

    actions: {
        async getCommentList ({commit}, query){
            const R = await commentList(query)
            let talkList = R.list
            // if(query.sort === 'desc'){
            //     talkList = R.list
            // }
            let userMap = R.userMap || {}
            
            commit('update', {
                talkList,
                userMap
            })    
            return R 
        },
    },


    mutations: {
        update,
    }
}